<template>
    <div d-flex flex-wrap>
        <div class="w-100">
            <app-form-text-input
                label="Titulo de la tarea"
                id="name"
                :required="true"
                :hasError="$v.task.name.$error"
                errorMessage="Debe escribir el nombre"
                @input="$v.task.name.$touch()"
                v-model="task.name"
            />
        </div>

        <div class="w-100">
            <div class="d-flex">
                <div class="w-50 pr-1">
                    <app-form-select-input
                        label="Cargo a asignar"
                        :options="this.positions"
                        v-model="positionId"
                        @change="
                            !!positionId
                                ? loadUsersByPosition(positionId)
                                : clean()
                        "
                    />
                </div>
                <div class="w-50 pl-1">
                    <app-form-select-input
                        label="Usuario Responsable"
                        :options="users"
                        v-model="task.assigneeId"
                        :hasError="$v.task.assigneeId.$error"
                        errorMessage="Debe seleccionar el usuario"
                        @change="$v.task.assigneeId.$touch()"
                        :required="true"
                        :disabled="!positionId"
                    />
                </div>
            </div>
        </div>
        <div class="w-100">
            <app-form-textarea-input
                label="Descripción"
                v-model="task.description"
                :hasError="$v.task.description.$error"
                errorMessage="Debe especificar su petición"
                :required="true"
                :rows="3"
                @input="$v.task.description.$touch()"
            />
        </div>
        <div class="w-100">
            <app-form-text-input
                label="Etiquetas"
                id="tags"
                description="Separe las etiquetas por espacios"
                v-model="task.tags"
            />
        </div>

        <b-row>
            <b-col>
                <label for="dueDate">Fecha de vencimiento</label>
                <b-form-input
                    type="datetime-local"
                    v-model="task.dueDate"
                    id="dueDate"
                    required
                    :hasError="$v.task.dueDate.$error"
                    errorMessage="Debe seleccionar la fecha de vencimiento"
                    @change="$v.task.dueDate.$touch()"
                ></b-form-input>
            </b-col>
            <b-col class="mt-4">
                <b-form-checkbox
                    id="checkbox1"
                    v-model="task.requireFiles"
                    :value="1"
                    :unchecked-value="0"
                >
                    La solución requiere archivos
                </b-form-checkbox>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col>
                <b-btn v-b-toggle.collapse1 size="sm" variant="primary"
                    >Agregar observador</b-btn
                >
            </b-col>
        </b-row>

        <b-collapse id="collapse1" class="mt-2">
            <b-card>
                <h6>Seleccione nombre observador</h6>
                <b-row>
                    <b-col cols="10">
                        <app-autocomplete
                            placeholder="Administrativos"
                            :items="administrativeUsers"
                            v-model="watcher"
                            results-prop="namePosition"
                        />
                    </b-col>
                    <b-col cols="1">
                        <b-btn variant="primary" @click="addWatcher"
                            ><i class="fa fa-plus" aria-hidden="true"></i
                        ></b-btn>
                    </b-col>
                </b-row>
                <div v-if="task.watchers.length">
                    <h5>Lista de observadores</h5>
                    <div v-for="watcher in task.watchers" :key="watcher.id">
                        <b-row>
                            <b-col cols="10">
                                <label
                                    >- {{ watcher.name }} ({{
                                        watcher.position.name
                                    }})
                                </label>
                            </b-col>
                            <b-col cols="2">
                                <b-btn
                                    size="sm"
                                    variant="danger"
                                    @click="removeWatcher(watcher)"
                                    ><i
                                        class="fa fa-times"
                                        aria-hidden="true"
                                    ></i
                                ></b-btn>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </b-card>
        </b-collapse>
        <app-upload-files
            id="task-files"
            title="Adjunte archivos relacionados a la tarea"
            v-model="files"
        ></app-upload-files>
    </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import UploadFiles from '../../../../../UI/Controls/Files/UploadFiles.vue'
import DatePicker from '../../../../../UI/Controls/DateTimePicker/DateTimePicker.vue'
import AutoComplete from '../../../../../UI/Controls/AutocompleteV2/Autocomplete.vue'
import userRepository from '../../../../../../repositories/users.repository.js'

export default {
    components: {
        appUploadFiles: UploadFiles,
        appDatePicker: DatePicker,
        appAutocomplete: AutoComplete,
    },
    props: {
        onSave: {
            type: Function,
        },
        contactReportId: {
            type: Number,
            default: 0,
        },
    },

    data() {
        return {
            positionId: '',
            users: [],
            task: {
                assigneeId: '',
                name: '',
                description: '',
                dueDate: '',
                requireFiles: 0,
                watchers: [],
                tags: '',
            },
            watcher: '',
            files: '',
            administrativeUsers: [],
        }
    },

    validations: {
        task: {
            name: { required },
            description: { required },
            dueDate: { required },
            assigneeId: { required },
        },
    },

    methods: {
        loadWatchers() {
            const ur = { ...userRepository }
            ur.getAdministrativeUsers()
                .then(data => {
                    data.map(item => {
                        ;(!item.name || !item.position) &&
                            console.log(item, item.position)
                        const administrativeUser = {
                            ...item,
                            namePosition:
                                item.name + ' (' + item.position.name + ')',
                        }
                        this.administrativeUsers.push(administrativeUser)
                    })
                })
                .catch(error => {
                    console.log('AssignmentTaskForm', error)
                    toastr.error('No se pudo cargar los administrativos')
                })
        },
        loadUsersByPosition(positionId) {
            this.task.assigneeId = ''
            this.$v.$reset()
            const ur = Object.assign({}, userRepository)
            ur.loadUsersByPosition(positionId)
                .then(data => {
                    this.users = data
                    if (data.length === 1) {
                        this.task.assigneeId = data[0].id
                    }
                })
                .catch(error => {
                    toastr.error('Error al cargar los usuarios de este cargo')
                })
        },
        clean() {
            this.users = []
            this.positionId = ''
            this.categoryId = ''
            this.task.assigneeId = ''
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },
        async addTask() {
            this.$v.$touch()
            if (this.$v.$invalid)
                return toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )

            this.startProcessing()

            const formData = new FormData()

            formData.append('creatorId', this.user.id)
            formData.append('assigneeId', this.task.assigneeId)
            formData.append('name', this.task.name)
            formData.append('description', this.task.description)
            formData.append('dueDate', this.task.dueDate)
            formData.set(
                'dueDate',
                this.task.dueDate.split('T').join(' ') + ':00'
            )
            formData.append('requireFiles', this.task.requireFiles)
            formData.append('tags', this.task.tags)
            formData.append('draft', true)
            !!this.contactReportId &&
                formData.append('contactReportId', this.contactReportId)

            // const {data} = await repo.post('tasks',formData);

            // if(data.status){
            //     this.stopProcessing();
            //     toastr.success(data.msg);
            // }else{
            //     this.stopProcessing();
            //     toastr.error(data.msg)
            // }
            let object = {}

            if (this.files.files) {
                //object.files = this.files;
                this.files.files.map((item, index) =>
                    formData.append('file' + index, item)
                )
            }

            if (this.task.watchers.length > 0) {
                //object.watchers = this.task.watchers;
                this.task.watchers.map(item => {
                    formData.append('watchers[watchers][]', item.id)
                })
            }

            try {
                const { data } = await repo.post('tasks', formData)
                if (!data.status) throw data.msg
                this.$emit('task-added', data.task)
            } catch (err) {
                toastr.error(err)
            } finally {
                this.stopProcessing()
            }

            // formData.forEach((value,key) => object[key] = value);
            // this.$bus.$emit('close-this-pop-up');
            // this.$bus.$emit('update');
        },
        addWatcher() {
            if (this.watcher) {
                this.task.watchers.push(this.watcher)
                this.watcher = ''
            } else {
                toastr.error('Ingrese el nombre del observador')
            }
        },
        removeWatcher(watcher) {
            const i = this.task.watchers.indexOf(watcher)
            this.task.watchers.splice(i, 1)
            toastr.success('Observador eliminado')
        },
        cleanForm() {
            Object.keys(this.task).map(key => (this.task[key] = ''))
            this.task.requireFiles = 0
            this.task.watchers = []
            this.positionId = ''
            this.files = ''
            this.$nextTick(() => {
                this.$v.$reset()
            })
            this.$bus.$emit('task-files.clean')
        },
    },

    computed: {
        ...mapGetters(['positions']),
        inferiorUsers() {
            if (!this.users) return []
            return this.users.filter(
                item =>
                    item.position.level >= this.user.position.level &&
                    this.user.id != item.id
            )
        }
    },

    mounted() {
        // this.$bus.$on('clear-data-contact-report-task-form', this.cleanForm);
        // this.$bus.$on('add-contact-report-task.save',this.saveTask);

        this.loadWatchers()
        this.load('positions')
    },

    beforeDestroy() {
        // this.$bus.$off('add-contact-report-task.save.save');
    },
}
</script>
